import { FC, useEffect, useState } from 'react';
import { Main, Spinner, TryAgainButton } from '../common/components';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { isObject, isObjectWith } from '../common/utils';
import translations from './VisualValidationGenerating.translations.json';
import { useNavigate } from 'react-router-dom';

const { addTranslations, useTranslation } = i18nNsFactory(
  'visual-validation-generating',
);
addTranslations(translations);

export const VisualValidationGenerating: FC = () => {
  const { t } = useTranslation();
  const [asyncError, setAsyncError] = useState<Error | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || !isObject(event.data)) {
        return;
      }

      // Atlas protocol allow-list: only ACK messages we actually handle, so
      // unrelated same-origin traffic (e.g. React DevTools' content script)
      // can't be mistaken for our ACK and stall the sender's retry loop.
      const isErrorMessage = isObjectWith(event.data.error, { message: '' });
      const isRedirectMessage = typeof event.data.redirectUrl === 'string';

      if (!isErrorMessage && !isRedirectMessage) {
        return;
      }

      window.postMessage('message-received');

      if (isErrorMessage) {
        const { message, stack } = event.data.error;
        setAsyncError(
          Object.assign(new Error(message), {
            stack,
            actions: (
              <TryAgainButton
                onClick={() => {
                  window.postMessage('try-again');
                }}
              />
            ),
          }),
        );
      } else {
        window.location.replace(event.data.redirectUrl);
      }
    };

    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, [navigate]);

  if (asyncError) {
    throw asyncError;
  }

  return (
    <Main>
      <Main.Col>
        <Main.Content scrollable={false}>
          <Spinner message={t('loading-message')} />
        </Main.Content>
      </Main.Col>
    </Main>
  );
};
